<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <global-table
          :table-data="employee"
          :loading="loading"
          :per-page="10"
          :bordered="true"
          :table-detail="tableDetail"
          :hover="true"
          :striped="false"
          :fields="fields"
          :row-edit="employeeForm"
          :redirect-detail="true"
          :show-add-button="true"
          caption="<i class='fa fa-align-justify'></i> Employee Listing"
          addButton="Tambah Employee"
          @resetForm="resetForm"
        ></global-table>
      </b-col>

      <b-modal
        ref="myModalRef"
        id="addModals"
        header-border-variant="no-border text-center"
        footer-border-variant="no-border"
        footer-bg-variant="light"
        :no-close-on-backdrop="true"
        :no-close-on-esc="true"
        hide-footer
        size="lg"
      >
        <div slot="modal-header" class="text-center">
          <h3 class="text-center">Input Karyawan Baru</h3>
        </div>

        <b-form id="employeeForm" validated novalidate @submit="submitAdd">
          <div v-if="!loadingSubmit">
            <b-row>
              <b-col sm="3">
                <b-form-group label-for="name" label="Nama Karyawan">
                  <b-form-input
                    id="name"
                    type="text"
                    v-model="$v.employeeForm.name.$model"
                    :state="!$v.employeeForm.name.$invalid"
                    required
                    placeholder="Nama Karyawan"
                  ></b-form-input>
                  <b-form-invalid-feedback>Nama karyawan harus di isi.</b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <b-col sm="3">
                <b-form-group label-for="surename" label="Nama Panggilan">
                  <b-form-input
                    id="surename"
                    type="text"
                    v-model="$v.employeeForm.surename.$model"
                    :state="!$v.employeeForm.surename.$invalid"
                    placeholder="Nama Panggilan"
                  ></b-form-input>
                  <b-form-invalid-feedback>Nama panggilan harus di isi.</b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <b-col sm="3">
                <b-form-group label-for="email" label="Email">
                  <b-form-input
                    id="email"
                    type="email"
                    v-model="$v.employeeForm.email.$model"
                    :state="!$v.employeeForm.email.$invalid"
                    required
                    placeholder="Email"
                  ></b-form-input>
                  <b-form-invalid-feedback>Email harus di isi.</b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <b-col sm="3">
                <b-form-group label-for="mobile_phone" label="No HP">
                  <b-form-input
                    id="mobile_phone"
                    type="text"
                    v-model="$v.employeeForm.mobile_phone.$model"
                    :state="!$v.employeeForm.mobile_phone.$invalid"
                    required
                    placeholder="No. HP"
                  ></b-form-input>
                  <b-form-invalid-feedback>No. HP harus di isi.</b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col sm="3">
                <b-form-group label-for="division_id" label="Divisi">
                  <b-form-select
                    id="division_id"
                    :options="listDivisionEmployee"
                    v-model="$v.employeeForm.division_id.$model"
                    :isError="$v.employeeForm.division_id.$invalid"
                    @change="getPosition($event)"
                    placeholder="-- Harap pilih salah satu --"
                    required
                  ></b-form-select>
                  <div
                    v-if="employeeForm.division_id === null"
                    class="invalid-feedback-custom"
                  >Divisi harus di isi.</div>
                </b-form-group>
              </b-col>

              <b-col sm="3">
                <b-form-group label-for="position_id" label="Posisi">
                  <b-form-select
                    id="position_id"
                    :options="listPositionEmployee"
                    v-model="$v.employeeForm.position_id.$model"
                    :isError="$v.employeeForm.position_id.$invalid"
                    placeholder="-- Harap pilih salah satu --"
                    required
                  ></b-form-select>
                  <div
                    v-if="employeeForm.position_id === null"
                    class="invalid-feedback-custom"
                  >Posisi harus di isi.</div>
                </b-form-group>
              </b-col>

              <b-col sm="3">
                <b-form-group label-for="payment_method" label="Metode Pembayaran">
                  <b-form-select
                    id="payment_method"
                    :options="listPaymentMethodEmployee"
                    v-model="$v.employeeForm.payment_method.$model"
                    :isError="$v.employeeForm.payment_method.$invalid"
                    placeholder="-- Harap pilih salah satu --"
                    required
                  ></b-form-select>
                  <div
                    v-if="employeeForm.payment_method === null"
                    class="invalid-feedback-custom"
                  >Metode pembayaran harus di isi.</div>
                </b-form-group>
              </b-col>

              <b-col sm="3">
                <b-form-group label-for="bank_name" label="Nama Bank">
                  <b-form-input
                    id="bank_name"
                    type="text"
                    v-model="$v.employeeForm.bank_name.$model"
                    :state="!$v.employeeForm.bank_name.$invalid"
                    required
                    placeholder="Nama Bank"
                  ></b-form-input>
                  <b-form-invalid-feedback>Nama bank harus di isi.</b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col sm="3">
                <b-form-group label-for="bank_account_number" label="Nomor rekening">
                  <b-form-input
                    id="bank_account_number"
                    type="text"
                    v-model="$v.employeeForm.bank_account_number.$model"
                    :state="!$v.employeeForm.bank_account_number.$invalid"
                    required
                    placeholder="Nomor Rekening"
                  ></b-form-input>
                  <b-form-invalid-feedback>Nomor rekening harus di isi.</b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <b-col sm="3">
                <b-form-group label-for="bank_account_name" label="Nama rekening">
                  <b-form-input
                    id="bank_account_name"
                    type="text"
                    v-model="$v.employeeForm.bank_account_name.$model"
                    :state="!$v.employeeForm.bank_account_name.$invalid"
                    required
                    placeholder="Nama Rekening"
                  ></b-form-input>
                  <b-form-invalid-feedback>Nama rekening harus di isi.</b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <b-col sm="3">
                <b-form-group label-for="start_join" label="Tanggal Bergabung">
                  <v-date-picker
                    id="start_join"
                    :input-props="{ class: 'form-control', placeholder: 'Tanggal Bergabung', required: ''}"
                    :state="!$v.employeeForm.start_join.$invalid"
                    v-model="$v.employeeForm.start_join.$model"
                  ></v-date-picker>
                  <div
                    v-if="$v.employeeForm.start_join.$invalid"
                    class="invalid-feedback-custom"
                  >Tanggal bergabung harus di isi.</div>
                </b-form-group>
              </b-col>

              <b-col sm="3">
                <b-form-group label-for="end_date" label="Tanggal Berakhir">
                  <v-date-picker
                    id="end_date"
                    :input-props="{ class: 'form-control', placeholder: 'Tanggal Berakhir'}"
                    :state="!$v.employeeForm.end_date.$invalid"
                    v-model="$v.employeeForm.end_date.$model"
                  ></v-date-picker>
                  <div
                    v-if="$v.employeeForm.end_date.$invalid"
                    class="invalid-feedback-custom"
                  >Tanggal berakhir harus di isi.</div>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col sm="3">
                <b-form-group label-for="id_number" label="No KTP">
                  <b-form-input
                    id="id_number"
                    type="text"
                    v-model="$v.employeeForm.id_number.$model"
                    :state="!$v.employeeForm.id_number.$invalid"
                    required
                    placeholder="No KTP"
                  ></b-form-input>
                  <b-form-invalid-feedback>No KTP harus di isi.</b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col sm="3">
                <b-form-group label-for="employee_ho" label="Lokasi Penempatan">
                  <b-form-select
                    id="employee_ho"
                    :options="listEmployeeHO"
                    v-model="$v.employeeForm.employee_ho.$model"
                    :isError="$v.employeeForm.employee_ho.$invalid"
                    
                    placeholder="-- Harap pilih salah satu --"
                    required
                  ></b-form-select>
                  <div
                    v-if="employeeForm.employee_ho === null"
                    class="invalid-feedback-custom"
                  >Lokasi penempatan harus di isi.</div>
                </b-form-group>
              </b-col>
               <b-col sm="3">
                <b-form-group label-for="religion" label="Agama">
                  <b-form-select
                    id="religion"
                    :options="listEmployeeReligion"
                    v-model="$v.employeeForm.religion.$model"
                    :isError="$v.employeeForm.religion.$invalid"
                    
                    placeholder="-- Harap pilih salah satu --"
                    required
                  ></b-form-select>
                  <div
                    v-if="employeeForm.religion === null"
                    class="invalid-feedback-custom"
                  >Agama harus di isi.</div>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col sm="6">
                <b-form-group label-for="address" label="Alamat">
                  <b-form-textarea
                    id="address"
                    :rows="3"
                    :max-rows="6"
                    v-model="$v.employeeForm.address.$model"
                    :state="!$v.employeeForm.address.$invalid"
                    required
                  ></b-form-textarea>
                  <b-form-invalid-feedback>Alamat harus di isi.</b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>

            <div class="float-right">
              <b-button type="button" size="sm" variant="danger" @click="cancelAdd">
                <i class="fa fa-undo"></i> Back
              </b-button>&nbsp;
              <b-button
                type="submit"
                size="sm"
                variant="primary"
                :disabled="$v.employeeForm.$invalid"
              >
                <i class="fa fa-save"></i> Save
              </b-button>
            </div>
          </div>
          <div v-else>
            <loading></loading>
          </div>
        </b-form>
      </b-modal>
    </b-row>
  </div>
</template>

<script>
import axios from "axios";
import globalTable from "../../templates/Table.vue";
import interfaces from "@/templates/_interfaces.js";
import { required, email } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";
import * as moment from "moment";
import "moment/locale/id";
import { ModelSelect } from "vue-search-select";
import loading from "@/templates/Loading.vue";

export default {
  name: "employee",
  components: { globalTable, ModelSelect, loading },
  props: {
    tableDetail: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      employee: [],
      employeeForm: interfaces.employee,
      listDivisionEmployee: [],
      listPositionEmployee: [],
      listEmployeeReligion: [],
      listPosition: [],
      listPaymentMethodEmployee: [],
      listEmployeeHO: [],
      loading: true,
      loadingSubmit: false,
      fields: [
        {
          key: "employee_profile",
          label: "Nama Karyawan",
          class: "width-250",
          sortable: true
        },
        { key: "email", label: "Email", class: "width-60", sortable: true },
        {
          key: "payment_method_name",
          label: "Metode Pembayaran",
          class: "width-150",
          sortable: true
        },
        {
          key: "division_name",
          label: "Divisi",
          class: "width-100",
          sortable: true
        },
        {
          key: "position_name",
          label: "Jabatan",
          class: "width-100",
          sortable: true
        },
        {
          key: "employee_bank_profile",
          label: "Bank Account",
          class: "width-150",
          sortable: true
        },
        { key: "action", class: "width-50 text-center" }
      ]
    };
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error"
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info"
    }
  },
  validations: {
    employeeForm: {
      name: { required },
      surename: {},
      username: {},
      email: { required },
      start_join: { required },
      end_date: {},
      mobile_phone: { required },
      division_id: { required },
      position_id: { required },
      payment_method: { required },
      bank_account_number: { required },
      bank_account_name: {},
      bank_name: {},
      parent: {},
      status: {},
      address: {},
      id_number: { required },
      religion: { required },
      employee_ho: { required }
    }
  },
  methods: {
    init: function() {
      this.loading = true;
      this.getAllEmployee();
      this.getDropdown();
    },
    getAllEmployee: function() {
      this.axios
        .get("web/employee/all/")
        .then(response => {
          this.employee = response.data.data;
        })
        .catch(error => {
          this.expired(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getDropdown: function() {
      this.axios
        .get("web/dropdown/employee/")
        .then(response => {
          this.listDivisionEmployee = response.data.employee_division;
          this.listPosition = response.data.employee_position;
          this.listPaymentMethodEmployee = response.data.employee_payment_method;
          this.listEmployeeHO = response.data.employee_head_office;
          this.listEmployeeReligion = response.data.employee_religion;
        })
        .catch(error => {
          this.expired(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getPosition: function(event) {
      this.listPositionEmployee = this.listPosition.filter(
        x => x.division_id === event
      );
    },
    cancelAdd: function() {
      this.resetForm();
      this.$refs.myModalRef.hide();
    },
    resetForm: function() {
      for (var a in interfaces.employee) {
        interfaces.employee[a] = null;
      }
      this.employeeForm = interfaces.employee;
    },
    submitAdd: function(evt) {
      evt.preventDefault();
      if (confirm("Apakah anda ingin menambahkan karyawan ini ?")) {
        this.loadingSubmit = true;
        let employee = this.employeeForm;
        this.axios
          .post("web/employee/add/", employee)
          .then(response => {
            if (response.data.status === 2000) {
              this.showInfoNotification({
                title: "Tambah Karyawan",
                message: response.data.message
              });
              this.$router.push({ path: "all/detail/" + response.data.id });
            }
          })
          .catch(error => {
            this.expired(error);
          })
          .finally(() => {
            this.loadingSubmit = false;
          });
      }
    },
    expired: function(error) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired"
        });
      } else {
        this.showErrorNotification({
          title: "Tambah Karyawan",
          message: error.response.data.message
        });
      }
    }
  },
  mounted() {
    this.init();
  }
};
</script>